module.exports = __webpack_public_path__ + "static/img/0002.9d010df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/0002.jpg
// module id = 1yiv
// module chunks = 1